<template>
  <div class="no-data" :class="noPaddingTop ? 'no-padding-t' : ''">
    <img class="empty_img" :src="imgUrl" :style="{ width: imgWidth }" />
    <div class="empty_text" :style="{ width: emptyTextWidth }">{{ emptyText }}</div>
    <span class="desc_text" v-if="descText">{{ descText }}</span>
  </div>
</template>

<script>
export default {
  name: 'noData',
  props: {
    imgUrl: {
      type: String,
      default: require('./icon_empty.png'),
    },
    emptyText: {
      // 无文字提示
      type: String,
      default: '暂无数据',
    },
    descText: {
      type: String,
    },
    btnText: {
      type: String,
      default: '刷新一下',
    },
    emptyTextWidth: {
      // 文本宽度
      type: String,
      default: '140px',
    },
    imgWidth: {
      // 图片宽度
      type: String,
      default: '180px',
    },
    noPaddingTop: Boolean, // 顶部不用留白
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.no-data {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: 100px;
  &.no-padding-t {
    padding-top: 0 !important;
  }
  .empty_text {
    font-size: 14px;
    color: #888;
    width: 165px;
    margin: 8px 0 14px;
    text-align: center;
  }
  .desc_text {
    font-size: 12px;
    color: #888888;
  }
}
</style>
